import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import { Notifications } from '@mui/icons-material';
import { withRouter } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      minWidth: 400,
      padding: theme.spacing(2),
    },
  },
  content: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  welcomeText: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
    fontWeight: 500,
  },
  notificationText: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  greetingText: {
    textAlign: 'left',
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  divider: {
    margin: theme.spacing(0, -2),
  },
  actions: {
    padding: theme.spacing(2),
    gap: theme.spacing(1),
  },
  dateText: {
    fontSize: 16,
    color: 'red',
    fontWeight: 'bold',
  },
  docText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

const NotifyDialog = ({ open, onClose, notificationCounts, history }) => {
  const classes = useStyles();
  const { admin_program_size, work_progress_size } = notificationCounts;

  const handleViewDetails = () => {
    history.push('/Manage/Main/system/notification/notification_admin_program');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      aria-labelledby="notify-dialog-title"
    >
      <DialogTitle id="notify-dialog-title">
        <div className={classes.titleContainer}>
          <Notifications color="primary" />
          系統通知
        </div>
      </DialogTitle>
      <Divider className={classes.divider} />
      <DialogContent className={classes.content}>
        <Typography variant="body1" className={classes.greetingText}>
          親愛的使用者您好,
        </Typography>
        <Typography variant="h6" className={classes.welcomeText}>
          歡迎使用風場基本資料系統
        </Typography>
        <Typography variant="body1" className={`${classes.notificationText} ${classes.dateText}`}>
          截至今日, {new Date().getFullYear()}年{new Date().getMonth() + 1}月{new Date().getDate()}日
        </Typography>
        <Typography variant="body1">
          
        </Typography>
        <Typography variant="body1" className={classes.notificationText}>
          尚未處理之 <span className={classes.docText}>行政程序</span> 文件: {admin_program_size} 筆
        </Typography>
        <Typography variant="body1" className={classes.notificationText}>
          尚未處理之 <span className={classes.docText}>工程進度</span> 文件: {work_progress_size} 筆
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={handleViewDetails} color="primary" variant="outlined">
          查看詳細
        </Button>
        <Button onClick={onClose} color="default" variant="outlined">
          關閉
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withRouter(NotifyDialog);
